import { KeyValuePipe } from '@angular/common';
import {
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { UiButtonComponent } from '@ui';

@Component({
  selector: 'options-table',
  imports: [
    UiButtonComponent,
    TranslatePipe,
    MatLabel,
    ReactiveFormsModule,
    KeyValuePipe,
  ],
  templateUrl: './options-table.component.html',
  styleUrl: './options-table.component.scss',
})
export class OptionsTableComponent {
  public paramsControls: InputSignal<AbstractControl<unknown, unknown>[]> =
    input<AbstractControl<unknown, unknown>[]>();
  public title: InputSignal<string> = input<string>();

  public deleteParamsOutput: OutputEmitterRef<number> = output<number>();
  public addParamsOutput: OutputEmitterRef<void> = output();

  public addParams(): void {
    this.addParamsOutput.emit();
  }

  public deleteParams(idx: number): void {
    this.deleteParamsOutput.emit(idx);
  }
}
